import React, { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Button,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
import BulkAddMarksModal from "./components/BulkAddMarksModal";
import Line from "./components/Line";
import { number } from "yup";

export default function Ratings() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isBulkAddOpen,
    onOpen: onBulkAddOpen,
    onClose: onBulkAddClose,
  } = useDisclosure();
  const [peoples, setPeoples] = useState([]);
  const [marksData, setMarksData] = useState([]);
  const [formattedData, setFormattedData] = useState({
    platoon1: [],
    platoon2: [],
    platoon3: [],
  });
  const [loading, setLoading] = useState(true);
  const [usersData, setUsersData] = useState([]);

  const fetchMarksAndAttendance = async () => {
    try {
      const [marksResponse, attendanceResponse] = await Promise.all([
        axios.get(apiUrl + "/data/school/company/marks/list", {
          headers: { "x-access-token": localStorage.getItem("token") },
        }),
        axios.get(apiUrl + "/data/school/company/attendance/remarks", {
          headers: { "x-access-token": localStorage.getItem("token") },
        }),
      ]);

      const marksData = marksResponse.data;
      const attendanceData = attendanceResponse.data;

      const formatted = {
        platoon1: [],
        platoon2: [],
        platoon3: [],
        platoon4: [],
      };

      marksData.forEach((item) => {
        const person =
          peoples.find((p) => p.value === item.userID)?.label ||
          "Nie odnaleziono użytkownika";
        const addedBy = peoples.find((p) => p.value === item.addedBy)?.label;
        const mark = {
          id: item.id,
          mark: item.mark,
          addedBy: addedBy,
          comment: item.comment,
          color: item.color,
        };

        if (person) {
          const platoonKey = `platoon${item.platoon}`;
          const existingPerson = formatted[platoonKey].find(
            (p) => p.userID === item.userID
          );

          if (existingPerson) {
            existingPerson.marks.push(mark);
          } else {
            console.log("attendancedata", attendanceData);
            const userAttendance = attendanceData.find(
              (user) => user.userID === item.userDBID
            ) || { remarks: [], attendance: [] };
            if (!userAttendance) {
              console.error("userAttendance is undefined", user);
              return;
            }
            console.log("item", item);
            formatted[platoonKey].push({
              userID: item.userID,
              userDBID: item.userDBID,
              login: usersData.find((user) => user.userID === item.userID)
                ?.login,
              number: usersData.find((user) => user.userID === item.userID)
                ?.number,
              archived: usersData.find((user) => user.userID === item.userID)
                ?.archived,
              nick: person,
              marks: [mark],
              remarks: userAttendance.remarks,
              attendance: userAttendance.attendance,
            });
          }
        }
      });

      // Dodaj użytkowników bez ocen
      usersData.forEach((user) => {
        const person =
          peoples.find((p) => p.value === user.userID)?.label ||
          "Nie odnaleziono użytkownika";
        const platoonKey = `platoon${user.platoon}`;
        if (!formatted[platoonKey].find((p) => p.userID === user.userID)) {
          const userAttendance = attendanceData.find(
            (userData) => userData.userID === user.id
          ) || { remarks: [], attendance: [] };
          if (!userAttendance) {
            console.error("userAttendance is undefined", user);
            return;
          }
          formatted[platoonKey].push({
            userID: user.userID,
            userDBID: user.id,
            number: user.number,
            login: user.login,
            archived: user.archived,
            nick: person,
            marks: [],
            remarks: userAttendance?.remarks,
            attendance: userAttendance.attendance,
          });
        }
      });
      console.log(formatted);
      setMarksData(marksData);
      setFormattedData(formatted);
      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error("Napotkano błąd podczas pobierania danych ocen");
      setLoading(false);
    }
  };

  const fetchPeoples = async () => {
    try {
      const response = await axios.get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      });
      setPeoples(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Napotkano błąd podczas pobierania danych użytkowników");
    }
  };

  const fetchUsersData = async () => {
    try {
      const response = await axios.get(
        apiUrl + "/data/school/company/users/list",
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      );
      setUsersData(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Napotkano błąd podczas pobierania danych użytkowników");
    }
  };

  const fetchCompanyData = async () => {
    let isMounted = true;

    try {
      const response = await axios.get(apiUrl + "/data/school/company/list", {
        headers: { "x-access-token": localStorage.getItem("token") },
      });

      if (isMounted) {
        return response.data.find((company) => company.active === 1)
          ? true
          : false;
      }
    } catch (error) {
      console.error(error);
    }

    return false;
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (await fetchCompanyData()) {
        if (isMounted) {
          fetchPeoples();
          fetchUsersData();
          fetchMarksAndAttendance();
        }
      } else {
        toast.error("Nie znaleziono aktywnej kompanii");
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (peoples.length > 0 && usersData.length > 0) {
      fetchMarksAndAttendance();
    }
  }, [peoples, usersData]);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px" gap="3">
        <Flex gap="5" direction="column">
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontSize="xl" fontWeight="bold">
              Zarządzanie ocenami
            </Text>
            {!localStorage.getItem("roles").includes("1150112550336335982") && (
              <Button colorScheme="blue" onClick={onBulkAddOpen}>
                Masowe dodawanie ocen
              </Button>
            )}
          </Flex>
          <TableContainer>
            <Table size="sm" variant="striped">
              <Thead>
                <Tr>
                  <Th>Pluton</Th>
                  <Th>Nr w plutonie</Th>
                  <Th>Nick</Th>
                  <Th>Oceny</Th>
                  <Th>Uwagi P | N</Th>
                  <Th>Frekwencja OB | NB | U</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.keys(formattedData).map((platoonKey) =>
                  formattedData[platoonKey]
                    .sort((a, b) => a.number - b.number)
                    .map((person, i) => (
                      <Line
                        key={person.userDBID}
                        i={i}
                        person={person}
                        platoon={platoonKey}
                        fetchMarksData={fetchMarksAndAttendance}
                        peoples={peoples}
                      />
                    ))
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Flex>
      </Card>
      <BulkAddMarksModal
        isOpen={isBulkAddOpen}
        onClose={onBulkAddClose}
        usersData={usersData}
        peoples={peoples}
        fetchMarksData={fetchMarksAndAttendance}
      />
    </Flex>
  );
}
